export const COLLAPSED = 'collapsed';

export const CRITERIA_CODE_DISPLAY_VALUES = {
  met: 'Met',
  unknown: 'Unknown',
  'not-met': 'Not Met'
};

export const CRITERIA_FILTERS = {
  unknown: true,
  met: false,
  'not-met': false
};

export const RECRUITMENT_ELIGIBILITY_SCORE_URL = 'https://labcorp.com/fhir/ctra/StructureDefinition/recruitment-eligibility-score';

export const UNKNOWN_ANSWER_CODING: fhir4.Coding = {
  system: 'https://labcorp.com/fhir/ctra/CodeSystem/questionnaire-response-item-answer',
  code: 'unknown',
  display: 'Unknown'
};
